import { Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import VerifyPinComponent, { ValidateCodeInputs } from 'components/Common/VerifyPinComponent';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { registerDevice, request2FAPin, validate2FA } from 'redux/slices/auth/authSlice';
import { AppDispatch } from 'redux/store';
import { getDeviceId } from 'utils/helpers';
import { notify } from 'components/Common/Toast';
import MuiLoader from 'components/Common/Loader';
import AuthLayaout from './AuthLayout';

const TwoFactorVerifyPin = ({ username, verifyPinCallback }: any) => {
    const dispatch = useDispatch<AppDispatch>();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState<boolean>(false);
    const [resendCodeLoading, setResendCodeLoading] = useState<boolean>(false);
    const [trustThisDevice, setTrustThisDevice] = useState(false);

    const handleVerify2FAPinCode = async (data: ValidateCodeInputs) => {
        const code = Object.values(data).join('');
        if (code.length < 6) {
            return setError('Please fill all the fields.');
        } else {
            setError('');
        }
        setLoading(true);
        const response: any = await dispatch(validate2FA({ pin2fa: code, username }));
        setLoading(false);
        if (response?.payload?.code === 200) {
            if (trustThisDevice) {
                const deviceId = await getDeviceId();
                await dispatch(registerDevice({ pin2fa: code, username, deviceId }));
            }
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            verifyPinCallback && verifyPinCallback();
        }
    };

    const handleResendCode = async () => {
        setResendCodeLoading(true);
        const response: any = await dispatch(request2FAPin({ twoFactorAuthType: 'EMAIL', username }));
        setResendCodeLoading(false);
        if (response?.payload?.code === 200) {
            notify('Code sent Successfully', 'success');
        }
    };

    return (
        <AuthLayaout>
            <Stack sx={{ height: 500 }}>
                <MuiLoader loading={resendCodeLoading} absolute />
                <Stack sx={{ p: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Stack spacing={1} sx={{ mt: 4, mx: 5 }}>
                        <p className="Auth-form-title">Two-Factor Authentication</p>
                        <Typography>
                            Enter the 6-digit code we have sent to the email you provided in order to verify your identity.
                        </Typography>
                        <VerifyPinComponent
                            validateCode={handleVerify2FAPinCode}
                            error={error}
                            setError={setError}
                            loading={loading}
                            handleResendCode={handleResendCode}
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={trustThisDevice}
                                        onChange={(e) => setTrustThisDevice(e.target.checked)}
                                        sx={{
                                            color: '#d3d3d3',
                                            '&.Mui-checked': {
                                                color: '#142456',
                                            },
                                        }}
                                    />
                                }
                                label="Trust this device."
                            />
                        </VerifyPinComponent>
                    </Stack>
                </Stack>
            </Stack>
        </AuthLayaout>
    );
};

export default TwoFactorVerifyPin;
